import { getRuntimeEnvValue } from '../runtimeEnv';
export const DEFAULT_REST_ENDPOINT = '/api/v1/get-service-history';
export function getServiceHistoryEndpoint() {
    return getRuntimeEnvValue('REST_ENDPOINT') || DEFAULT_REST_ENDPOINT;
}
